import React from 'react';
import { Flex, Image, rem, Text } from '@feast-it/pesto';
import { ThemeProvider } from 'emotion-theming';
import {
  baseTheme,
  Button as ButtonUI,
  TextLink as TextLinkUI,
} from '@feast-it/ui';

import JoinToolTip from '../../../components/JoinToolTip';
import TEAM from '../../../constants/team';
import paths from '../../../constants/paths';
import { trackEvent } from '../../../modules/analytics';
import { SUPPLIER_FORM_START_CLICKED } from '../../../constants/analytics';

const SupplierWelcome = () => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      height="77vh"
    >
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Image
          src={TEAM['Seb'].image}
          alt="Seb"
          inView={true}
          mb={6}
          mt={rem(56)}
          borderRadius="round"
          width={1}
          height={1}
          layoutProps={{
            width: 104,
            height: 104,
          }}
        />

        <Text
          as="h1"
          fontFamily="heading"
          fontSize={{ _: 'headingExtraLargeMobile', m: 'display' }}
          fontWeight={500}
          lineHeight={{ _: 'headingExtraLargeMobile', m: 'display' }}
          mb={{ _: 4, m: 2 }}
        >
          Join Togather!
        </Text>

        <Text
          fontFamily="body"
          fontSize={{ _: 'body', m: 'headingMediumMobile' }}
          width={{ _: 'auto', m: rem(759) }}
          textAlign="center"
          lineHeight={{ _: 'body', m: 'headingMediumMobile' }}
          mb={3}
        >
          I&apos;m{' '}
          <Text
            as="span"
            color="blueMedium"
            lineHeight={{ _: 'body', m: 'headingMediumMobile' }}
            fontFamily="body"
            fontSize={{ _: 'body', m: 'headingMediumMobile' }}
          >
            Seb
          </Text>
          , and I&apos;m here to build and support Togather&apos;s growing
          supplier community.
        </Text>
      </Flex>

      <Flex flexDirection="column" alignItems="center">
        <JoinToolTip
          message={
            'Submit your application and a member of the team will be in touch.'
          }
        />

        <Flex mt={3}>
          <ThemeProvider theme={baseTheme}>
            <ButtonUI
              type="submit"
              color="mediumBlue"
              variant="solid"
              onClick={() => {
                trackEvent(SUPPLIER_FORM_START_CLICKED, {
                  url: window.location.href,
                });
              }}
            >
              Get started
            </ButtonUI>
          </ThemeProvider>
        </Flex>
      </Flex>

      <Text mt={2} pb={2} fontFamily="body" fontSize="body" lineHeight="body">
        Already started your application?{' '}
        <ThemeProvider theme={baseTheme}>
          <TextLinkUI
            color="mediumRed"
            href={paths.LOGIN}
            style="bodyMedium"
            isInline={true}
          >
            Sign in
          </TextLinkUI>
        </ThemeProvider>
      </Text>
    </Flex>
  );
};

export default SupplierWelcome;
